import { render, staticRenderFns } from "./CallPartnerTariffZones.vue?vue&type=template&id=d449a0a0&"
import script from "./CallPartnerTariffZones.vue?vue&type=script&lang=ts&"
export * from "./CallPartnerTariffZones.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports